import useForm from "./useForm";
import {Context} from "./Context";
import Domov from "./Domov";

export function HomePage({configPath, preloadSestav, showPrice}) {
    return (
        <Domov configPath={configPath} preloadSestav={preloadSestav} showPrice={showPrice}/>
    );
}
